<template>
  <div id="app">
    <div class="header">
      <h1><img src="./assets/logo.png"></h1>
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
        <el-menu-item index="1" @click="turn('Home')">首页</el-menu-item>
        <!-- <el-menu-item index="2" >产品中心</el-menu-item> -->
        <el-menu-item index="3" @click="turn('AboutUs')">关于美蓓</el-menu-item>
        <el-menu-item index="4" @click="turn('ConcatUs')">联系我们</el-menu-item>
      </el-menu>
    </div>
    <router-view/>
    <div class="footer">
      <h6><img src="./assets/footer.png"></h6>
      <h6 style="padding: 10px 0; margin-top: 0;"><a href="https://beian.miit.gov.cn/" target="_blank">京ICP备18056576号-1</a></h6>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data : function(){
    return {
      activeIndex : '1'
    }
  },
  methods:{
    turn(name){
      this.$router.push({
        name : name
      })
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0 20px;
}
h1{
  margin: 20px auto;
}
.el-card{
  margin-bottom: 20px;
}

.footer{
background: #F5F5F5;
}
.footer img{
  display: block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue